import { z } from 'zod'
import { IS_US_POSTAL_CODE_MESSAGE, REQUIRED_MESSAGE } from '@Const/error-messages'
import { isCountryCAN, isCountryUS, isPostcodeRequiredCountry } from '@App/common/utils'
import { validateUsPostalCode } from '@App/helpers/validate'
import { cityKey, countryKey, postalCodeKey, stateKey } from '@Entities/schemas/common/address-schema-keys'

export const refineCountry = (address: any, ctx: z.RefinementCtx) => {
    if (isCountryUS(address.countryId) || isCountryCAN(address.countryId)) {
        if (!address.state) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: [stateKey],
            })
        }
    }

    if (isPostcodeRequiredCountry(address.countryId)) {
        if (!address.postalCode) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: REQUIRED_MESSAGE,
                path: [postalCodeKey],
            })
        }
    }

    if (isCountryUS(address.countryId)) {
        if (!validateUsPostalCode(address.postalCode)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: IS_US_POSTAL_CODE_MESSAGE,
                path: [postalCodeKey],
            })
        }
    }
}

export const refineRegisterMemberAddress = (address: any, ctx: z.RefinementCtx) => {
    const anyAddressFieldHasValueWhileOthersDont =
        (address.streetAddress !== undefined &&
            address.streetAddress.length > 0 &&
            (!address.city || !address.countryId)) ||
        (address.city !== undefined && address.city.length > 0 && (!address.streetAddress || !address.countryId)) ||
        (address.countryId !== undefined && address.countryId.length > 0 && (!address.streetAddress || !address.city))

    if (anyAddressFieldHasValueWhileOthersDont) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Required', path: ['streetAddress'] })
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Required', path: [cityKey] })
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Required', path: [countryKey] })
    }
    refineCountry(address, ctx)
}
